import i18next from 'i18next';
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useMemo } from "react";
import { getColumns, redirect } from './config';
import { LinkingContext } from '../../../context/Linking';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { LinkedSubjects } from '../../../services';
import DafTable from '../../Table/newTable';
import TablePagination from '../../Table/pagination';
import { useFilters } from '../../../helpers/SubjectSearch';
import { useLocation } from 'react-router-dom';

const emptyObject = {};

export default function LinkingTemplate({ conf, namespace }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { data, addData } = useContext(LinkingContext);
  const view = useMemo(() => location.pathname.split(`/app/${conf.mod}/`)[1], [location, conf]);

  const {
    pagination,
    onTableChange,
    totalPages,
    canGoNext,
    canGoPrev,
    setPagination,
    goPrev,
    goNext,
  } = useFilters({
    module: conf.mod,
    view,
    selectFiltersConfig: emptyObject,
    filtersConfig: emptyObject,
  });

  const columns = getColumns({
    t,
    redirect,
    mod: conf.mod,
    language: i18next.language,
    mode: conf.mode,
  });
  const id = conf.allData.datastakeId;

  const dataSource = data[id];

  const changeData = async () => {
    try {
      const _data = await LinkedSubjects.getLinkedSubjects({ namespace, id, mod: conf.mod })
      const data = (_data?.data || []).map((d, i) => ({ ...d, key: `${d.id}-${i}` }));
      addData(id, data);
      setPagination((prev) => ({ ...prev, current: 1, total: data.length ? data.length : 1 }));
    }
    catch (err) {
      console.log(err);
    }
  };

  const _dataSource = useMemo(() => {
    const startIndex = pagination.pageSize * (pagination.current - 1);
    const endIndex = Math.min(startIndex + pagination.pageSize, dataSource?.length || 0);
    return [...(dataSource || [])].slice(startIndex, endIndex);
  }, [pagination, dataSource]);

  useEffect(() => {
    if (!dataSource) {
      changeData();
    } else {
      setPagination((prev) => ({ ...prev, current: 1, total: dataSource.length ? dataSource.length : 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={formatClassname([
        'content',
        'documents-layout',
      ])}
      style={{}}
    >
      <div className="view-header" style={{ flexDirection: 'column', paddingTop: 0 }}>
        <div className='daf-table-wrapper pagination-no-padding'>
          <DafTable
            className="mt-0 p-0"
            columns={columns}
            hideOnLoading={false}
            data={_dataSource}
            doEmptyRows
            loading={!dataSource}
            rowKey="key"
            pagination={pagination}
            size="small"
          />

          <TablePagination
            t={t}
            page={pagination.current}
            totalPages={totalPages}
            goPrev={goPrev}
            goNext={goNext}
            canGoNext={canGoNext}
            canGoPrev={canGoPrev}
            totalItems={pagination.total}
            doTotalItems
            onChangePagination={(val) => {
              onTableChange({ ...pagination, current: 1, pageSize: val });
            }}
            perPage={pagination.pageSize}
            arrowIcons
          />
        </div>
      </div>
    </div>
  )
}
